import { BitkitAlert, BitkitAlertProps } from '@bitrise/bitkit-v2';

import useAlert from '@/hooks/useAlert';

type AlertSlotProps = Omit<BitkitAlertProps, 'variant' | 'messageText' | 'titleText'>;
const AlertSlot = ({ onClose, ...rest }: AlertSlotProps) => {
  const { alert, removeAlert } = useAlert();
  const handleClose = () => {
    removeAlert();
    onClose?.();
  };

  return alert?.message ? (
    <BitkitAlert
      variant={alert.variant}
      dismissible
      onClose={handleClose}
      titleText={alert.title}
      messageText={alert.message}
      {...rest}
    />
  ) : null;
};

export default AlertSlot;
